(<template>
  <div class="assignment-buttons">
    <button v-for="(link, index) in filteredLinks"
            :key="index"
            class="assignment-buttons__item assignment-button"
            @click="handleLinkClick(link)">
      <div class="assignment-button__image"
           :class="link.iconClass"></div>
      <span class="assignment-button__text">{{ link.text }}</span>
      <div class="assignment-button__arrow-icon"></div>
    </button>
  </div>
</template>)

<script>
  import {mapGetters} from 'vuex';
  import constants from '@/modules/constants';

  export default {
    computed: {
      ...mapGetters('UserInfoStore', ['userCanSeeTranslations', 'disableOtherServices']),
      postTranslationLink() { return this.$isGodmode() ? `${constants.CONNECT_PATH?.replace(/\/+$/, '')}/create-translation-order?customeruid=${this.$store.getters['UserInfoStore/userUid']}` : this.$makeRoute({name: 'BuyerPostTranslationProject'}); },
      links() {
        return [
          {
            text: this.$gettext('Book an interpreter'),
            type: 'router-link',
            iconClass: 'book-interpreter-icon',
            condition: true,
            action: this.$makeRoute({name: 'BuyerPostInterpretation'})
          },
          {
            text: this.$gettext('Order translation'),
            type: 'router-link',
            iconClass: 'order-translation-icon',
            condition: !this.userCanSeeTranslations,
            action: this.postTranslationLink
          },
          {
            text: this.$gettext('Book sign language translator'),
            type: 'router-link',
            iconClass: 'book-sign-lang-icon',
            condition: true,
            action: this.$makeRoute({name: 'BuyerOtherServiceAssignment', params: {service: 1}})
          },
          {
            text: this.$gettext('Other services'),
            type: 'router-link',
            iconClass: 'other-service-icon',
            condition: !this.disableOtherServices,
            action: this.$makeRoute({name: 'BuyerOtherServiceAssignment', params: {service: 'other'}})
          }
        ];
      },
      filteredLinks() { return this.links.filter((link) => link.condition); }
    },
    methods: {
      handleLinkClick(link) {
        const action = typeof link.action === 'function' ? link.action() : link.action;
        typeof action === 'string' ? window.open(action, '_blank') : this.$router.push(action);
      },
    }
  };
</script>

<style scoped>
  .assignment-buttons {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  .assignment-buttons__item {
    display: flex;
    flex: 1;
    align-items: center;
    width: 24%;
    padding: 15px;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: var(--block-shadow);
    cursor: pointer;
  }

  .assignment-buttons__item:hover {
    background-color: var(--assignment-quick-booking-hover-color);
    box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0), 0 1px 2px 0 rgba(255, 255, 255, 0);
    transition: ease-in-out 0.125s;
  }

  .assignment-buttons__item:hover .assignment-button__arrow-icon {
    margin-right: 10px;
  }

  .assignment-buttons__item:focus {
    outline: var(--focus-outline);
  }

  .assignment-button__image {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: var(--assignment-quick-booking-icon-bg-color);
    background-position: center center;
    background-repeat: no-repeat;
  }

  .book-interpreter-icon {
    background-image: var(--quick-book-interpreter-icon);
  }

  .order-translation-icon {
    background-image: var(--quick-book-translator-icon);
  }

  .book-sign-lang-icon {
    background-image: var(--quick-book-sign-lang-icon);
  }

  .other-service-icon {
    background-image: var(--quick-book-other-services-icon);
  }

  .assignment-button__text {
    padding: 0 15px 0 15px;
    font-weight: 400;
    font-size: 14px;
  }

  .assignment-button__arrow-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-left: auto;
    background-image: url(~@assets/imgs/salita/dashboard_icons/arrow_to_right_grey.svg);
    background-repeat: no-repeat;
  }

  @media (max-width: 850px) {
    .assignment-buttons__item {
      padding: 10px;
    }

    .assignment-button__text {
      padding: 0 10px 0 10px;
    }
  }

  @media (max-width: 767px) {
    .assignment-buttons {
      flex-wrap: wrap;
      gap: 12px;
    }

    .assignment-buttons__item {
      display: block;
      width: 47%;
    }

    .assignment-button__arrow-icon {
      display: none;
    }

    .assignment-button__image {
      width: 24px;
      height: 24px;
      margin-bottom: 12px;
      background-color: transparent;
    }

    .assignment-button__text {
      padding: 0;
      font-size: 14px;
    }
  }
</style>
